module.exports = __webpack_public_path__ + "img/Spark2.1e4ae9eb.png";